var _rect, _g, _rect2, _rect3, _rect4, _path, _path2, _circle, _rect5, _rect6, _rect7, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4088_70860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4088_70860)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_4088_70860)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 57.7071,
    y: -14.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 57.7071 -14.3809)",
    stroke: "#DBDBDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -35.2078,
    y: 28,
    width: 294.982,
    height: 151.027,
    rx: 20,
    transform: "rotate(45 -35.2078 28)",
    fill: "#F4FAFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-43 85L108 85C113.523 85 118 89.4772 118 95V190C118 195.523 113.523 200 108 200H-43L-43 85Z",
    fill: "url(#paint0_linear_4088_70860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 85.5L108 85.5C113.247 85.5 117.5 89.7533 117.5 95V190C117.5 195.247 113.247 199.5 108 199.5H-42.5L-42.5 85.5Z",
    stroke: "#B2B9C0",
    strokeOpacity: 0.42
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 189,
    r: 4.5,
    stroke: "#E4E4E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 277.121,
    y: 247.33,
    width: 83.7326,
    height: 112.427,
    rx: 7.5,
    transform: "rotate(-45 277.121 247.33)",
    stroke: "#F0F5FC",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4088_70860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6251 136H74.1251C72.1257 136 70.5 137.626 70.5 139.625V158.375C70.5 160.374 72.1257 162 74.1251 162H101.875C103.874 162 105.5 160.374 105.5 158.375V139.625C105.5 137.626 103.874 136 101.875 136H74.6251Z",
    stroke: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5001 145.25C91.5001 147.045 92.9549 148.5 94.75 148.5C96.545 148.5 97.9999 147.045 97.9999 145.25C97.9999 143.455 96.545 142 94.75 142C92.955 142 91.5001 143.455 91.5001 145.25Z",
    fill: "#EAF1FB",
    stroke: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 155.375C88.5 155.72 88.7801 156 89.125 156H100.375C100.72 156 101 155.72 101 155.375V154.625C101 152.626 99.3743 151 97.3749 151H92.1251C90.1257 151 88.5 152.626 88.5 154.625V155.375Z",
    fill: "#EAF1FB",
    stroke: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.625 156.5H83.8749C84.4959 156.5 84.9999 155.996 84.9999 155.375C84.9999 154.754 84.4959 154.25 83.8749 154.25H75.625C75.004 154.25 74.5 154.754 74.5 155.375C74.5 155.996 75.004 156.5 75.625 156.5Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.625 150.5H83.8749C84.4959 150.5 84.9999 149.996 84.9999 149.375C84.9999 148.754 84.4959 148.25 83.8749 148.25H75.625C75.004 148.25 74.5 148.754 74.5 149.375C74.5 149.996 75.004 150.5 75.625 150.5Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.625 144.5H83.8749C84.4959 144.5 84.9999 143.996 84.9999 143.375C84.9999 142.754 84.4959 142.25 83.8749 142.25H75.625C75.004 142.25 74.5 142.754 74.5 143.375C74.5 143.996 75.004 144.5 75.625 144.5Z",
    fill: "#EAF1FB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4088_70860",
    x1: 37,
    y1: 100,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4088_70860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4088_70860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "matrix(-1 0 0 1 106 131)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCardBackground);
export default __webpack_public_path__ + "static/media/users-card-background.efa5869619182d8382b57e7582afa66e.svg";
export { ForwardRef as ReactComponent };